import { useGlobalContext, useSearch, } from '@honeycomb/data';
import { RadioGroup, Stacker, TypographyHeading, TypographyBody, Button } from '@honeycomb/ui-core';
import React, { useEffect, useState } from 'react';
import { interjectResourceString, pluraliseCount } from '../../../../utils';
import { RoomOptionGroupContext } from './RoomOptionGroup.context';
import { RoomOptionCard } from '../RoomOptionCard/RoomOptionCard';
export function RoomOptionGroup(props) {
    var _a, _b, _c, _d, _e;
    const { onRoomChange, onDetailsClick, onSubBoardDetailsClick, roomIndex, room, hasInclusionDetails, selectedRoom, totalBookedPrice, } = props;
    const { resourceStrings: { ROOMSHOWMORE, ADULT, ADULTS, CHILD, CHILDREN, HOTEL_ROOM }, configSettings: { DefaultRoomsToShow }, } = useGlobalContext();
    const [{ rooms }] = useSearch([]);
    const [showAll, setShowAll] = useState(false);
    const DEFAULT_ROOM_LENGTH = DefaultRoomsToShow ? parseInt(DefaultRoomsToShow) : 2;
    const selectedRoomIndex = ((_b = (_a = room.availableRooms) === null || _a === void 0 ? void 0 : _a.findIndex((availableRoom) => availableRoom.roomId === (selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.boardRoomId))) !== null && _b !== void 0 ? _b : 0) +
        1;
    if (selectedRoomIndex > DEFAULT_ROOM_LENGTH && !showAll) {
        setShowAll(true);
    }
    const selectedRoomOccupancy = rooms[roomIndex];
    const roomAdults = (_c = selectedRoomOccupancy === null || selectedRoomOccupancy === void 0 ? void 0 : selectedRoomOccupancy.adults) !== null && _c !== void 0 ? _c : 0;
    const roomChildren = (_d = selectedRoomOccupancy === null || selectedRoomOccupancy === void 0 ? void 0 : selectedRoomOccupancy.childAges) === null || _d === void 0 ? void 0 : _d.length;
    // Event handler for room details click
    const handleRoomDetailsClick = React.useCallback((masterRoom) => (event) => {
        event.stopPropagation();
        onDetailsClick === null || onDetailsClick === void 0 ? void 0 : onDetailsClick(masterRoom);
    }, [onDetailsClick]);
    // Event handler for board details click
    const handleSubBoardDetailsClick = React.useCallback((event) => {
        event.stopPropagation();
        onSubBoardDetailsClick === null || onSubBoardDetailsClick === void 0 ? void 0 : onSubBoardDetailsClick();
    }, [onSubBoardDetailsClick]);
    useEffect(() => setShowAll(false), [room]);
    const contextValue = React.useMemo(() => {
        return {
            hasInclusionDetails,
            selectedRoom: selectedRoom !== null && selectedRoom !== void 0 ? selectedRoom : null,
            onRoomDetailsClick: handleRoomDetailsClick,
            onSubBoardDetailsClick: handleSubBoardDetailsClick,
            totalBookedPrice,
        };
    }, [hasInclusionDetails, selectedRoom, handleRoomDetailsClick, handleSubBoardDetailsClick, totalBookedPrice]);
    const adultsString = `(${roomAdults} ${pluraliseCount(roomAdults, {
        singular: ADULT,
        plural: ADULTS,
    })}`;
    const childrenString = `${roomChildren} ${pluraliseCount(roomChildren, {
        singular: CHILD,
        plural: CHILDREN,
    })}`;
    return (React.createElement(Stacker, { spacing: 4 },
        rooms.length > 1 && (React.createElement(Stacker, { direction: "row", "data-id": `room${roomIndex}-radiogroup-label` },
            React.createElement(TypographyHeading, { size: "s", color: "text.body" },
                HOTEL_ROOM,
                " ",
                roomIndex + 1,
                ":"),
            React.createElement(TypographyBody, { size: "m", color: "text.light" },
                adultsString,
                roomChildren ? `, ${childrenString}` : '',
                ")"))),
        React.createElement(RoomOptionGroupContext.Provider, { value: contextValue },
            React.createElement(RadioGroup, { value: selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.boardRoomId, onChangeValue: (roomId) => {
                    var _a;
                    onRoomChange === null || onRoomChange === void 0 ? void 0 : onRoomChange((_a = room.availableRooms) !== null && _a !== void 0 ? _a : [], roomId, roomIndex);
                }, "data-id": `room${roomIndex}-radiogroup` },
                React.createElement(Stacker, { spacing: 4 }, (_e = room.availableRooms) === null || _e === void 0 ? void 0 : _e.slice(0, showAll ? room.availableRooms.length : DEFAULT_ROOM_LENGTH).map((availableRoom, i) => {
                    return (React.createElement(RoomOptionCard, { availableRoom: availableRoom, key: availableRoom.roomId, index: i }));
                })))),
        !showAll && (room === null || room === void 0 ? void 0 : room.availableRooms) && (room === null || room === void 0 ? void 0 : room.availableRooms.length) > DEFAULT_ROOM_LENGTH && (React.createElement(Button, { color: "primary", size: "l", variant: "outlined", fullWidth: true, onClick: () => setShowAll(true), "data-id": `show-more-rooms-room${roomIndex}` }, `${interjectResourceString(ROOMSHOWMORE, room.availableRooms.length - DEFAULT_ROOM_LENGTH)}`))));
}
